import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import {  store } from "./store";
import { SnackbarProvider } from "notistack";
import AppNew from "AppNew";
import { PersistGate } from "redux-persist/integration/react";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <SnackbarProvider maxSnack={4}>
      {/* <PersistGate loading={null} persistor={persistor}> */}
        <Provider store={store}>
          <AppNew />
        </Provider>
      {/* </PersistGate> */}
    </SnackbarProvider>
  </BrowserRouter>,

  // </React.StrictMode>
);
